import React, { useEffect, useState, useCallback } from "react";
// import db from '../../db/index.json'
import LeftSection from "../../component/dashboard-section/panels/left-panel";
import RightSection from "../../component/dashboard-section/panels/right-panel";
import MainSection from "../../component/dashboard-section/profile-complete/main";
import * as DataAction from "../../store/actions/data/DataAction";
import * as AuthAction from "../../store/actions/auth/AuthAction";
import { useDispatch, useSelector } from "react-redux";
import BaseUrl from "../../constants/BaseUrl";
import MyLoader from "../../component/reusebale/myLoader";
import { ShowError } from "../../utils/ToasFunction";
import { useNavigate } from "react-router-dom";
import Chatbot from "../../component/chatboat/chatboatUI";

const Dashboard = () => {
  const dispatch = useDispatch();
  const [activeComponent, setActiveComponent] = useState("Home");
  const [isCheckProfile, setCheckProfile] = useState(false);
  const { loginSuccess, profileCompleted, userCompleteProfile } = useSelector(
    (state) => state.auth
  );
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  console.log("userCompleteProfile", userCompleteProfile);

  // Check if user is authenticated on component mount
  useEffect(() => {
    if (!loginSuccess) {
      // If no login data, check localStorage and hydrate state
      const savedLogin = localStorage.getItem("loginSuccess");
      if (savedLogin) {
        dispatch(AuthAction.HydrateStateAction());
      } else {
        // No login data found, redirect to login
        navigate("/login", { replace: true });
        return;
      }
    }
  }, [loginSuccess, dispatch, navigate]);

  const handleItemClick = (componentName) => {
    if (componentName === "Logout") {
      dispatch(AuthAction.LogoutAction());
      navigate("/login", { replace: true });
      return;
    }
    setActiveComponent(componentName); // Update active component
  };

  const showDashboard = (componentName) => {
    if (loginSuccess) {
      dispatch(
        AuthAction.GetTenantProfile(loginSuccess.user._id, loginSuccess.token)
      );
    }
  };

  useEffect(() => {
    if (loginSuccess) {
      dispatch(
        AuthAction.GetTenantProfile(loginSuccess.user._id, loginSuccess.token)
      );
      dispatch(DataAction.GetAllMasterData());
    }
  }, [loginSuccess, dispatch]);

  useEffect(() => {
    if (userCompleteProfile && profileCompleted && !loader) {
      setCheckProfile(true);
    } else if (userCompleteProfile && !profileCompleted && !loader) {
      setCheckProfile(false);
    }
  }, [profileCompleted, userCompleteProfile, loader]);

  const GetLeaseDetail = useCallback(
    (id) => {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      };

      fetch(`${BaseUrl}api/lease/getLeaseDetails/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.success) {
            if (profileCompleted) {
              setCheckProfile(true);
              setLoader(false);
            } else {
              setCheckProfile(false);
              setLoader(false);
            }
            // if (result?.data?.status === "active") {
            //   setLoader(false);
            // } else {
            //   setLoader(false);
            //   ShowError("Lease is not active");
            // }
          } else {
            setLoader(false);
            ShowError("Failed to fetch lease details");
          }
        })
        .catch((error) => {
          console.error("Error fetching lease details:", error);
          setLoader(false);
          ShowError("Error fetching lease details");
        });
    },
    [loginSuccess?.token, profileCompleted]
  );

  const GetLeasesById = useCallback(() => {
    if (!loginSuccess?.user?._id || !loginSuccess?.token) {
      setLoader(false);
      ShowError("Authentication required");
      return;
    }

    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${loginSuccess?.token}`);
    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${BaseUrl}api/lease/getLeaseDetailsByTenantId/${loginSuccess?.user?._id}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (result?.data && result.data.length > 0 && result.data[0]?.leaseId) {
          const leaseId = result?.data[0]?.leaseId;
          GetLeaseDetail(leaseId);
        } else {
          setLoader(false);
          // No lease found, check if profile is completed
          if (profileCompleted) {
            setCheckProfile(true);
          } else {
            setCheckProfile(false); // Show profile completion
          }
          console.log("No lease found for tenant");
        }
      })
      .catch((error) => {
        console.error("Error fetching leases:", error);
        setLoader(false);
        ShowError("Error fetching lease information");
      });
  }, [
    loginSuccess?.token,
    loginSuccess?.user?._id,
    GetLeaseDetail,
    profileCompleted,
  ]);

  useEffect(() => {
    if (loginSuccess) {
      GetLeasesById();
    }
  }, [loginSuccess, GetLeasesById]);

  // Add timeout to prevent infinite loading
  useEffect(() => {
    const timeout = setTimeout(() => {
      if (loader) {
        console.log("Loading timeout reached, stopping loader");
        setLoader(false);
        // Respect profile completion state even on timeout
        if (profileCompleted) {
          setCheckProfile(true);
        } else {
          setCheckProfile(false); // Show profile completion
        }
      }
    }, 10000); // 10 second timeout

    return () => clearTimeout(timeout);
  }, [loader, profileCompleted]);

  const [showBot, setShowBot] = useState(false);
  return (
    <div className="flex justify-center items-center w-[98%] mx-auto h-screen">
      {loader ? (
        <div>
          <MyLoader />
        </div>
      ) : (
        <>
          {!isCheckProfile ? (
            <div className="w-[90%] mx-auto h-full flex items-center">
              <MainSection isComplete={showDashboard} />
            </div>
          ) : (
            <>
              <div className="w-[20%] h-[97vh]">
                <LeftSection onItemClick={handleItemClick} />
              </div>
              <div className="w-[80%] pl-6 h-screen overflow-scroll scrollbar-hide panelScroll">
                <RightSection
                  showChatBot={(val) => {
                    setShowBot(val);
                  }}
                  activeComponent={activeComponent}
                  setActiveComponent={setActiveComponent}
                />
              </div>
              {showBot && <Chatbot />}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Dashboard;
